import   MainStyle  		from "components/UI/main.module.scss";
import { useState } 		from 'react';
import { BtnCloseAction }	from "components/Buttons/Close/BtnClose";

// This will manage the modal state globally
let showModalCallback 	= null;
let hideModalCallback 	= null;

export const useModal = () => {
  const showModal = (...args) => {
    if (typeof showModalCallback === "function") {
      showModalCallback(...args);
    }
  };

  const hideModal = () => {
    if (typeof hideModalCallback === "function") {
      hideModalCallback();
    }
  };

  return { showModal, hideModal };
};

export const Modal = () => {
  	const [displayModal, setDisplayModal] = useState(false);
  	const [body, setBody] = useState(null);
  	const [confirmAction, setConfirmAction] = useState(() => () => {}); // Store confirm callback

	showModalCallback = (children, confirm_action) => {
		setBody(children);
		if (confirm_action) {
			setConfirmAction(() => () => {
			confirm_action();
			setDisplayModal(false);
			});
		} else {
			setConfirmAction(null);
		}

		setDisplayModal(true);
	};

	hideModalCallback = () => setDisplayModal(false);


	const closePopUp = () => setDisplayModal(false);

	return (
		<>
			{displayModal && (
				<div className={[MainStyle.modal_child].join(" ")}>
					<div className={[MainStyle.modal_dialog].join(" ")}>
						<div className={[MainStyle.modal_content, MainStyle.rounded_3, MainStyle.shadow_sm, MainStyle.border, MainStyle.mx_2].join(" ")}>
							<div className={[MainStyle.bg_card, MainStyle.border_bottom, MainStyle.rounded_top_3].join(" ")}>
								<div className={MainStyle.row}>
									<div className={MainStyle.col}>
										<div className={[MainStyle.text_end, MainStyle.m_1].join(" ")}>
											{<BtnCloseAction click_action={closePopUp}/>}
										</div>
									</div>
								</div>
							</div>
							<div>
								{body}
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

